import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledUsageStats = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .stats-title {
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
    color: ${COLOR.darkBlue};
    text-align: center;
    margin: 0 0 16px 0;
  }

  .stats-description {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: ${COLOR.label2[64]};
    text-align: center;
    margin-bottom: 40px;
  }

  .stats-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 40px;
  }

  .cta-row {
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 768px) {
    .stats-title {
      font-size: 24px;
    }

    .stats-grid {
      grid-template-columns: 1fr;
    }

    .cta-row {
      justify-content: stretch;

      .MuiButtonBase-root {
        width: 100%;
      }
    }
  }
`;
